import { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit, MdLink, MdOpenInNew } from "react-icons/md";
import Card from "components/card";
import { api } from "api";

const LINK_CATEGORIES = ["Resmi Kurumlar", "Muhasebe Programlari", "Diger Faydali"];

const Links = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [form, setForm] = useState({ name: "", url: "", category: "Resmi Kurumlar", sort_order: 0 });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    api.getLinks().then(setItems).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const openCreate = () => {
    setEditId(null);
    setForm({ name: "", url: "", category: "Resmi Kurumlar", sort_order: 0 });
    setError("");
    setShowForm(true);
  };

  const openEdit = (item: any) => {
    setEditId(item.id);
    setForm({ name: item.name, url: item.url, category: item.category, sort_order: item.sort_order });
    setError("");
    setShowForm(true);
  };

  const handleSave = async () => {
    setError("");
    if (!form.name || !form.url) { setError("Ad ve URL zorunludur"); return; }
    try {
      if (editId) {
        await api.updateLink(editId, form);
        setMsg("Link guncellendi!");
      } else {
        await api.createLink(form);
        setMsg("Link eklendi!");
      }
      setShowForm(false);
      load();
      setTimeout(() => setMsg(""), 3000);
    } catch (e: any) { setError(e.message); }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Bu linki silmek istediginize emin misiniz?")) return;
    await api.deleteLink(id);
    load();
  };

  // Kategoriye gore grupla
  const grouped = LINK_CATEGORIES.map(cat => ({
    category: cat,
    links: items.filter(i => i.category === cat),
  })).filter(g => g.links.length > 0);

  return (
    <div>
      {msg && <div className="mb-4 rounded-xl bg-green-50 p-3 text-sm text-green-700">{msg}</div>}

      <div className="mt-3 flex items-center justify-between">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">Faydali Linkler ({items.length})</h4>
        <button onClick={openCreate} className="flex items-center gap-2 rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600 transition">
          <MdAdd className="h-5 w-5" /> Yeni Link
        </button>
      </div>

      {loading ? (
        <p className="mt-8 text-center text-gray-500">Yukleniyor...</p>
      ) : items.length === 0 ? (
        <Card extra="mt-4 p-8">
          <div className="text-center">
            <MdLink className="mx-auto h-12 w-12 text-gray-300 mb-3" />
            <p className="text-gray-500">Henuz link eklenmedi</p>
          </div>
        </Card>
      ) : (
        grouped.map(g => (
          <Card extra="mt-4 p-4" key={g.category}>
            <h5 className="font-bold text-navy-700 dark:text-white mb-3">{g.category}</h5>
            <div className="space-y-2">
              {g.links.map((item) => (
                <div key={item.id} className="flex items-center justify-between rounded-xl border border-gray-100 px-4 py-3 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700/50 transition">
                  <div className="flex items-center gap-3 flex-1">
                    <img src={`https://www.google.com/s2/favicons?domain=${new URL(item.url).hostname}&sz=32`} alt="" className="h-6 w-6 rounded" />
                    <div>
                      <p className="font-medium text-navy-700 dark:text-white">{item.name}</p>
                      <p className="text-xs text-gray-400">{item.url}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <a href={item.url} target="_blank" rel="noreferrer" className="text-gray-400 hover:text-brand-500"><MdOpenInNew className="h-5 w-5" /></a>
                    <button onClick={() => openEdit(item)} className="text-brand-500 hover:text-brand-700"><MdEdit className="h-5 w-5" /></button>
                    <button onClick={() => handleDelete(item.id)} className="text-red-400 hover:text-red-600"><MdDelete className="h-5 w-5" /></button>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        ))
      )}

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setShowForm(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white p-6 dark:bg-navy-800" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-4">{editId ? "Link Duzenle" : "Yeni Link"}</h3>
            {error && <div className="mb-4 rounded-xl bg-red-50 p-3 text-sm text-red-600">{error}</div>}
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Site Adi *</label>
                <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Orn: GIB" className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">URL *</label>
                <input type="url" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })}
                  placeholder="https://..." className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Kategori</label>
                <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white">
                  {LINK_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Sira (kucuk sayi once gosterilir)</label>
                <input type="number" min={0} value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: Number(e.target.value) })}
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button onClick={() => setShowForm(false)} className="rounded-xl px-5 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-100">Iptal</button>
              <button onClick={handleSave} className="rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600">{editId ? "Guncelle" : "Ekle"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Links;
